import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "confirmationview" }
const _hoisted_2 = { class: "topbar" }
const _hoisted_3 = { class: "space flex column v-center" }
const _hoisted_4 = { class: "row center large-gap" }
const _hoisted_5 = { class: "box center flex column complete-box" }
const _hoisted_6 = { class: "row small" }
const _hoisted_7 = { class: "box" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "activity-title bold" }
const _hoisted_10 = {
  key: 0,
  class: "item-entry"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  class: "row center waivers"
}
const _hoisted_13 = { class: "box large-gap flex" }
const _hoisted_14 = { class: "scan-me" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "row flex column gap center fill" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_si_icon = _resolveComponent("si-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "logo" }, "Confirmation", -1)),
      _createElementVNode("div", {
        class: "backbutton",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.done && _ctx.done(...args)))
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("div", null, "Done", -1)
      ]))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "row bold gap" }, [
            _createElementVNode("div", { class: "gg-check-o" }),
            _createElementVNode("div", null, "Order Complete")
          ], -1)),
          _createElementVNode("div", _hoisted_6, "A confirmation email has been sent to " + _toDisplayString(_ctx.activeOrder?.customerInfo.Email ?? 'None') + ".", 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row" }, "Upcoming:", -1)),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderModule.itemActivities, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "entry",
                key: item.orderEntityKey ?? -1
              }, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(item.name), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.selectedTimes, (time) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "item",
                    key: time.TimeString
                  }, [
                    (time.AppointmentTypeKey != 3)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                          _createTextVNode(_toDisplayString(time.AppointmentDate) + " ", 1),
                          (time.AppointmentTypeKey == 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, " at " + _toDisplayString(time.TimeString), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(time.Rates.filter((r) => r.Participants > 0), (rate) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "item-entry",
                        key: rate.OrderEntityTimeKey ?? -1
                      }, _toDisplayString(rate.Name) + " x " + _toDisplayString(rate.Participants), 1))
                    }), 128))
                  ]))
                }), 128))
              ]))
            }), 128))
          ])
        ])
      ]),
      (_ctx.activeOrder?.collectWaivers)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("img", {
                  src: _ctx.qrImage,
                  width: "220",
                  height: "220"
                }, null, 8, _hoisted_15),
                _cache[6] || (_cache[6] = _createElementVNode("span", null, "Scan Me", -1))
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "bold" }, "Waivers", -1)),
                _createElementVNode("div", null, "Everyone in your party " + _toDisplayString(_ctx.clientModule.location?.AdultAge ?? '18') + "+ needs to complete a waiver before beginning the activity today.", 1),
                _createVNode(_component_si_icon, { name: "scan_me" }),
                _cache[9] || (_cache[9] = _createElementVNode("div", null, "Scan the QR code using the camera of your mobile device and follow the link.", -1)),
                _createElementVNode("button", {
                  onTouchstart: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.completeOnDevice && _ctx.completeOnDevice(...args))),
                  class: "flex-row justify-center"
                }, [
                  _cache[7] || (_cache[7] = _createTextVNode("Complete on this device ", -1)),
                  _createVNode(_component_si_icon, { name: 'chevron_right' })
                ], 32)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}